import React, { useEffect, useRef } from 'react';
import { Box, Typography, Paper } from '@mui/material';

/**
 * Live Captions Component
 * Displays live captions from the transcript during the meeting
 */
function LiveCaptions({ transcript, isVisible }) {
  const captionsRef = useRef(null);

  // Auto-scroll to bottom when new transcript arrives
  useEffect(() => {
    if (captionsRef.current) {
      captionsRef.current.scrollTop = captionsRef.current.scrollHeight;
    }
  }, [transcript]);

  if (!isVisible) {
    return null;
  }

  // Get last 3 lines of transcript for display
  const getRecentCaptions = () => {
    if (!transcript || transcript.trim().length === 0) {
      return 'Waiting for speech...';
    }

    const lines = transcript.trim().split('\n').filter(line => line.trim().length > 0);
    const recentLines = lines.slice(-3); // Get last 3 lines

    // Remove timestamps for cleaner display
    return recentLines
      .map(line => line.replace(/^\[.*?\]\s*/, ''))
      .join(' ')
      .trim();
  };

  return (
    <Paper
      ref={captionsRef}
      sx={{
        position: 'fixed',
        bottom: 100,
        left: '50%',
        transform: 'translateX(-50%)',
        maxWidth: '80%',
        width: { xs: '90%', sm: '70%', md: '60%' },
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        color: 'white',
        borderRadius: 2,
        px: 3,
        py: 2,
        zIndex: 9998,
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
      }}
      elevation={8}
    >
      <Typography
        variant="body1"
        sx={{
          textAlign: 'center',
          fontSize: { xs: '0.9rem', sm: '1rem' },
          lineHeight: 1.6,
          fontWeight: 500,
        }}
      >
        {getRecentCaptions()}
      </Typography>
    </Paper>
  );
}

export default LiveCaptions;
